/**
 * button
 */
export default (element = document.querySelectorAll(".button"), callback) => {
  for (let i = 0; i < element.length; i++) {
    element[i].addEventListener("click", callback);
  }
};
